import React, { FC, useCallback, useState } from "react"
import { Modal } from "../modal"
import styled from "styled-components"
import { Button, Input, Title } from "@giphy/react-giphy-brand"

const ModalContentWrapper = styled.div<{ topOffset?: number }>`
  max-width: 340px;
  width: calc(100% - 8px);
  min-width: 200px;
  background: rgb(33, 33, 33);
  box-shadow: 0px 6px 25px 0px rgba(0, 0, 0, 0.61);
  border-radius: 6px;
  padding: 28px;
  // * M A G I C N U M B E R S *
  // the images get moved upwards using the top property with absolute positioning to sit them outside the container
  // the first image has a top of -55, and this padding needs to be 50 to fit design
  // the second image has a top of -95, and this padding needs to be 28 to fit design
  // x - 55y = 50
  // x - 95y = 28
  // solving for x and y, x = 80.25 and y = 0.55
  padding-top: ${({ topOffset }) => (80.25 + 0.55 * (topOffset || 0))}px;
  position: relative;
  box-sizing: border-box;
  text-align: center;
`

const ModalHeaderImage = styled.img<{ topOffset?: number }>`
  position: absolute;
  top: ${({ topOffset }) => `${topOffset}px`};
  width: 200px;
  left: calc(50% - 100px);
`

const ModalTitle = styled(Title)``

const ModalText = styled.div`
  margin-top: 15px;
  margin-bottom: 25px;
  line-height: 1.3;
`

const ModalInput = styled(Input)`
  border-radius: 2px;
  overflow: hidden;
`

const ModalCTA = styled(Button)`
  width: 100%;
  background: linear-gradient(90deg, #6157ff 0%, #9933ff 100%);
  border-radius: 2px;
  font-weight: bold;
`

const ModalClose = styled.button`
  width: 100%;
  background-color: transparent;
  border: none;
  color: white;
  font-weight: bold;
  padding: 12px;
  font-size: 12px;
`

export type SignupRecoveryModalProps = {
    title?: string,
    text?: string,
    inputPlaceholder?: string,
    ctaText?: string,
    ctaClickCallback?: (string) => void,
    closeText?: string,
    closeClickCallback?: (object) => void
    image?: string,
    imageTopOffset?: number,
}

const SignupRecoveryModal: FC<SignupRecoveryModalProps> = ({ imageTopOffset, image, title, text, closeText = 'Close', closeClickCallback, ctaClickCallback, ctaText, inputPlaceholder }) => {
    const [inputValue, setInputValue] = useState('')

    const inputChangeCallback = useCallback((event) => {
        setInputValue(event.target.value)
    }, [])

    return <Modal>
        <ModalContentWrapper topOffset={imageTopOffset}>
            <ModalHeaderImage src={image} topOffset={imageTopOffset}/>
            <ModalTitle>{title}</ModalTitle>
            <ModalText>{text}</ModalText>
            <ModalInput inputProps={{ placeholder: inputPlaceholder, onChange: inputChangeCallback, value: inputValue }}></ModalInput>
            <ModalCTA type="button" onClick={() => {
                if (ctaClickCallback) {
                    ctaClickCallback(inputValue)
                }
            }}>{ctaText}</ModalCTA>
            <ModalClose onClick={closeClickCallback} type="button">{closeText}</ModalClose>
        </ModalContentWrapper>
    </Modal>
}

export default SignupRecoveryModal
